import { Pipe, PipeTransform } from '@angular/core';
import { User } from '@shared/models';

@Pipe({ name: 'name', })
export class NamePipe implements PipeTransform {
  transform(user: { firstName?: string, lastName?: string }) {
    return user?.firstName + ' ' + user?.lastName;
  }
}
